/* solum-pre-owned-b2c.js
 * B2C Pre-Owned catalog embedded on /pages/myaccount, styled like the
 * Department Store section. Prices in KRW (supplier +10%, fixed FX rate).
 *   • Browse / search the pre-owned catalog (condition pills + free text)
 *   • Click a card image → gallery modal with ALL the supplier photos
 *   • BUY NOW → POST /storefront/pre-owned-b2c/cart-item {customer_id,id}
 *     → backend forges hidden product + draft order → returns invoice_url
 *     → redirect to Shopify hosted checkout (KRW). Guest → login.
 * Supplier name is never exposed.
 */
(function () {
  'use strict';
  var P = document.querySelector('.po-b2c');
  if (!P) return;

  var API = P.getAttribute('data-api-url') || 'https://solum-concierge-api.onrender.com';
  var cid = P.getAttribute('data-customer-id') || '';
  var lang = (P.getAttribute('data-lang') || 'en').toLowerCase();
  /* Marché (localization.country) : JP → prix en yen, sinon won */
  var MARKET = (P.getAttribute('data-market') || 'KR').toUpperCase();
  var isJpMkt = MARKET === 'JP';
  var isGuest = P.hasAttribute('data-guest');
  var isKo = lang.indexOf('ko') >= 0;
  var isJa = lang.indexOf('ja') >= 0;

  var T = {
    searching: isKo ? '검색 중…' : (isJa ? '検索中…' : 'Searching…'),
    noResults: isKo ? '결과가 없습니다.' : (isJa ? '結果がありません。' : 'No results found.'),
    searchErr: isKo ? '검색에 실패했습니다.' : (isJa ? '検索に失敗しました。' : 'Search failed.'),
    buyNow: isKo ? '구매하기' : (isJa ? '今すぐ購入' : 'Buy now'),
    preparing: isKo ? '주문 생성 중…' : (isJa ? '注文を作成中…' : 'Preparing order…'),
    redirecting: isKo ? '결제 페이지로 이동…' : (isJa ? '決済ページへ移動…' : 'Redirecting to checkout…'),
    buyErr: isKo ? '주문 생성 실패: ' : (isJa ? '注文作成失敗: ' : 'Order failed: '),
    counter1: isKo ? '개의 결과' : (isJa ? '件の結果' : ' result'),
    counterN: isKo ? '개의 결과' : (isJa ? '件の結果' : ' results'),
    noImage: isKo ? '이미지 없음' : (isJa ? '画像なし' : 'No image'),
    preowned: 'PRE-OWNED',
    allIncluded: isKo ? '세금 · 관세 · 배송비 포함' : (isJa ? '税金・関税・送料込み' : 'Tax, customs & shipping included'),
    photos: isKo ? '사진' : (isJa ? '写真' : 'Photos'),
    loading: isKo ? '로딩 중…' : (isJa ? '読み込み中…' : 'Loading…'),
    incl: isKo ? '구성품' : (isJa ? '付属品' : 'Inclusions'),
    cond: isKo ? '상태' : (isJa ? 'コンディション' : 'Condition'),
    condNotes: isKo ? '상태 설명' : (isJa ? 'コンディション詳細' : 'Condition notes'),
    serial: isKo ? '시리얼' : (isJa ? 'シリアル' : 'Serial'),
  };

  var krwLocale = isKo ? 'ko-KR' : (isJa ? 'ja-JP' : 'en-US');
  function fmtKRW(n) { return (isJpMkt ? '¥' : '₩') + Math.round(Number(n) || 0).toLocaleString(krwLocale); }
  function esc(s) { if (s == null) return ''; var d = document.createElement('div'); d.textContent = String(s); return d.innerHTML; }
  function $(id) { return document.getElementById(id); }

  var STATE = { query: '', condition: '', sort: 'newest', offset: 0, limit: 48 };
  var LAST = [];

  var form = $('pob2cSearchForm');
  var input = $('pob2cQ');
  var btn = $('pob2cSearchBtn');
  var btnLabel = btn ? btn.querySelector('.po-b2c__search-btn-label') : null;
  var btnSpin = btn ? btn.querySelector('.po-b2c__search-btn-spinner') : null;
  var statusEl = $('pob2cStatus');
  var grid = $('pob2cResults');
  var pills = $('pob2cPills');
  var pagEl = $('pob2cPagination');

  function setStatus(text, variant) {
    if (!statusEl) return;
    if (!text) { statusEl.hidden = true; statusEl.textContent = ''; return; }
    statusEl.hidden = false; statusEl.textContent = text;
    statusEl.className = 'po-b2c__status' + (variant ? ' po-b2c__status--' + variant : '');
  }
  function setSearching(busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    if (btnLabel) btnLabel.hidden = !!busy;
    if (btnSpin) btnSpin.hidden = !busy;
  }

  function cardHtml(r, i) {
    var imgs = Array.isArray(r.images) ? r.images.filter(Boolean) : [];
    var img = imgs[0]
      ? '<img class="po-b2c__card-img" loading="lazy" src="' + esc(imgs[0]) + '" alt="' + esc(r.name) + '">'
      : '<div class="po-b2c__card-img po-b2c__card-img--missing">' + esc(T.noImage) + '</div>';
    var condBadge = r.condition
      ? '<span class="po-b2c__card-source po-b2c__card-source--cond" data-cond="' + esc(r.condition) + '">' + esc(r.condition) + '</span>'
      : '';
    var brand = r.brand ? '<div class="po-b2c__card-brand">' + esc(r.brand) + '</div>' : '';
    return ''
      + '<article class="po-b2c__card" data-idx="' + i + '">'
      +   '<div class="po-b2c__card-media" data-action="gallery">'
      +     '<span class="po-b2c__card-source">' + esc(T.preowned) + '</span>'
      +     condBadge
      +     img
      +     '<span class="po-b2c__card-zoom">⤢ ' + esc(T.photos) + '</span>'
      +   '</div>'
      +   '<div class="po-b2c__card-body">'
      +     brand
      +     '<h3 class="po-b2c__card-title">' + esc(r.name) + '</h3>'
      +   '</div>'
      +   '<footer class="po-b2c__card-foot">'
      +     '<div class="po-b2c__card-price-wrap">'
      +       '<div class="po-b2c__card-price">' + fmtKRW(r.price_local || r.price_krw) + '<span class="po-b2c__card-price-unit">' + (isJpMkt ? 'JPY' : 'KRW') + '</span></div>'
      +       '<div class="po-b2c__card-price-incl">' + esc(T.allIncluded) + '</div>'
      +     '</div>'
      +     '<button type="button" class="po-b2c__card-btn" data-action="buy">'
      +       '<span class="po-b2c__card-btn-label">' + esc(T.buyNow) + '</span>'
      +     '</button>'
      +   '</footer>'
      + '</article>';
  }

  function renderResults(d) {
    grid.innerHTML = '';
    var results = d.items || [];
    if (!results.length) { grid.innerHTML = '<div class="po-b2c__empty">' + esc(T.noResults) + '</div>'; setStatus(''); pagEl.innerHTML = ''; return; }
    setStatus(d.total.toLocaleString(krwLocale) + (d.total === 1 ? T.counter1 : T.counterN), 'ok');
    LAST = results;
    grid.innerHTML = results.map(cardHtml).join('');
    Array.prototype.forEach.call(grid.querySelectorAll('.po-b2c__card'), function (card) {
      card.__item = results[parseInt(card.getAttribute('data-idx'), 10)];
    });
    renderPagination(d.total);
  }

  function renderPagination(total) {
    if (!pagEl) return;
    var pages = Math.ceil(total / STATE.limit);
    if (pages <= 1) { pagEl.innerHTML = ''; return; }
    var cur = Math.floor(STATE.offset / STATE.limit) + 1;
    var html = '<button type="button" data-page="' + (cur - 1) + '"' + (cur === 1 ? ' disabled' : '') + '>‹</button>';
    var start = Math.max(1, cur - 3), end = Math.min(pages, start + 6);
    if (end - start + 1 < 7) start = Math.max(1, end - 6);
    for (var p = start; p <= end; p++) html += '<button type="button" data-page="' + p + '"' + (p === cur ? ' class="is-active"' : '') + '>' + p + '</button>';
    html += '<button type="button" data-page="' + (cur + 1) + '"' + (cur === pages ? ' disabled' : '') + '>›</button>';
    pagEl.innerHTML = html;
    pagEl.querySelectorAll('button[data-page]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = parseInt(b.getAttribute('data-page'), 10);
        if (isNaN(p) || p < 1) return;
        STATE.offset = (p - 1) * STATE.limit;
        runSearch();
        P.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function runSearch() {
    setStatus(T.searching, '');
    grid.innerHTML = '';
    setSearching(true);
    var params = new URLSearchParams();
    if (STATE.query) params.set('q', STATE.query);
    if (STATE.condition) params.set('condition', STATE.condition);
    params.set('sort', STATE.sort);
    params.set('limit', STATE.limit);
    params.set('offset', STATE.offset);
    if (cid) params.set('customer_id', cid);
    params.set('market', MARKET);
    fetch(API + '/storefront/pre-owned-b2c/search?' + params.toString())
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setSearching(false);
        if (!d || !d.ok) { setStatus(T.searchErr + ' (' + ((d && d.error) || '?') + ')', 'err'); return; }
        renderResults(d);
      })
      .catch(function (e) { setSearching(false); setStatus(T.searchErr + ' (' + (e && e.message) + ')', 'err'); });
  }

  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); STATE.query = (input.value || '').trim(); STATE.offset = 0; runSearch(); });
  if (pills) {
    pills.addEventListener('click', function (e) {
      var b = e.target.closest('.po-b2c__pill'); if (!b) return;
      pills.querySelectorAll('.po-b2c__pill').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      STATE.condition = b.getAttribute('data-condition') || '';
      STATE.offset = 0; runSearch();
    });
  }

  /* ── Card actions: gallery + buy ── */
  grid.addEventListener('click', function (e) {
    var buyBtn = e.target.closest('.po-b2c__card-btn[data-action="buy"]');
    if (buyBtn) { doBuy(buyBtn); return; }
    var media = e.target.closest('.po-b2c__card-media[data-action="gallery"]');
    if (media) {
      var card = media.closest('.po-b2c__card');
      var it = card && card.__item;
      if (it) openModal(it);
    }
  });

  function doBuy(buyBtn) {
    var card = buyBtn.closest('.po-b2c__card');
    var item = card && card.__item;
    if (!item) return;
    if (isGuest || !cid) {
      window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
      return;
    }
    buyBtn.disabled = true;
    var labelEl = buyBtn.querySelector('.po-b2c__card-btn-label');
    var orig = labelEl ? labelEl.textContent : '';
    if (labelEl) labelEl.innerHTML = '<span class="po-b2c__card-btn-spinner"></span> ' + esc(T.preparing);
    fetch(API + '/storefront/pre-owned-b2c/cart-item', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cid, id: item.id, market: MARKET }),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (resp) {
        if (!resp.ok || !resp.data || !resp.data.ok || !resp.data.invoice_url) throw new Error((resp.data && resp.data.error) || 'create_failed');
        if (labelEl) labelEl.innerHTML = '<span class="po-b2c__card-btn-spinner"></span> ' + esc(T.redirecting);
        window.location.href = resp.data.invoice_url;
      })
      .catch(function (e) {
        if (labelEl) labelEl.textContent = orig;
        buyBtn.disabled = false;
        alert(T.buyErr + (e && e.message || 'unknown'));
      });
  }

  /* ── Gallery modal (reuses .po-modal markup; probes _2.._N images) ── */
  var modal = $('poModal'), modalMain = $('poModalMainImg'), modalThumbs = $('poModalThumbs'), modalBody = $('poModalBody');
  var modalCurrent = null, GAL = [], GAL_CUR = 0, PROBE = 0;
  function closeModal() { if (modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); } document.body.style.overflow = ''; modalCurrent = null; PROBE++; }
  if (modal) {
    modal.querySelectorAll('[data-po-modal-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
  }
  function galSet(i) { if (i < 0 || i >= GAL.length) return; GAL_CUR = i; modalMain.innerHTML = '<img src="' + esc(GAL[i]) + '" alt="">'; modalThumbs.querySelectorAll('.po-modal__thumb').forEach(function (t, j) { t.classList.toggle('is-active', j === i); }); }
  function galThumbs() {
    modalThumbs.innerHTML = GAL.map(function (src, i) { return '<button class="po-modal__thumb' + (i === GAL_CUR ? ' is-active' : '') + '" data-i="' + i + '"><img src="' + esc(src) + '" alt=""></button>'; }).join('');
    modalThumbs.querySelectorAll('.po-modal__thumb').forEach(function (t) { t.addEventListener('click', function () { galSet(parseInt(t.getAttribute('data-i'), 10)); }); });
  }
  function probeMore() {
    var first = GAL[0] || ''; var m = first.match(/^(.*_)(\d+)\.(jpe?g|png|webp)$/i); if (!m) return;
    var prefix = m[1], ext = m[3], n = parseInt(m[2], 10) + 1, MAX = n + 28, token = PROBE;
    (function next() {
      if (token !== PROBE || n > MAX) return;
      var url = prefix + n + '.' + ext, img = new Image();
      img.onload = function () { if (token !== PROBE) return; if (GAL.indexOf(url) === -1) { GAL.push(url); galThumbs(); } n++; next(); };
      img.onerror = function () {};
      img.src = url;
    })();
  }
  function metaPair(l, v) { if (v == null || v === '' || v === '0') return ''; return '<dt>' + esc(l) + '</dt><dd>' + esc(v) + '</dd>'; }
  function section(l, v) { if (!v) return ''; return '<div><div style="font-family:ui-monospace,monospace;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#888;margin-bottom:6px">' + esc(l) + '</div><div class="po-modal__desc">' + esc(v).replace(/\n/g, '<br>') + '</div></div>'; }
  function renderBody(it, loading) {
    modalBody.innerHTML = ''
      + '<div class="po-modal__brand">' + esc(it.brand || '—') + '</div>'
      + (it.condition ? '<span class="po-card__condition" data-cond="' + esc(it.condition) + '">' + esc(it.condition) + '</span>' : '')
      + '<h2 class="po-modal__name">' + esc(it.name || '') + '</h2>'
      + '<div class="po-modal__priceblock"><div class="po-modal__price">' + fmtKRW(it.price_local || it.price_krw) + ' <span style="font-size:.6em">' + (isJpMkt ? 'JPY' : 'KRW') + '</span></div>'
      +   '<div class="po-modal__pricenote">' + esc(T.allIncluded) + '</div></div>'
      + '<dl class="po-modal__meta">'
      +   metaPair('SKU', it.sku) + metaPair(T.cond, it.condition)
      +   metaPair(isKo ? '컬러' : (isJa ? 'カラー' : 'Color'), it.color_detail)
      +   metaPair(isKo ? '소재' : (isJa ? '素材' : 'Material'), it.material)
      +   metaPair(isKo ? '원산지' : (isJa ? '原産国' : 'Made in'), it.made_in)
      +   metaPair(isKo ? '카테고리' : (isJa ? 'カテゴリー' : 'Category'), it.category_string)
      +   metaPair(T.serial, it.serial)
      + '</dl>'
      + section(T.condNotes, it.condition_notes) + section(T.incl, it.inclusions)
      + section(isKo ? '설명' : (isJa ? '説明' : 'Description'), it.description)
      + (loading ? '<div class="po-modal__loading" style="padding:14px 0">' + esc(T.loading) + '</div>' : '')
      + '<div class="po-modal__add"><button type="button" class="po-card__confirm" id="pob2cModalBuy">' + esc(T.buyNow) + '</button></div>';
    var mb = $('pob2cModalBuy');
    if (mb) mb.addEventListener('click', function () {
      // Reuse the same buy flow as the card.
      var fake = document.createElement('div'); fake.className = 'po-b2c__card-btn'; fake.innerHTML = '<span class="po-b2c__card-btn-label">' + esc(T.buyNow) + '</span>';
      var holder = document.createElement('div'); holder.className = 'po-b2c__card'; holder.__item = it; holder.appendChild(fake);
      doBuy(fake);
    });
  }
  function openModal(it) {
    if (!modal) return;
    modalCurrent = it; PROBE++;
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    GAL = (it.images || []).filter(Boolean); GAL_CUR = 0;
    if (GAL.length) { galThumbs(); galSet(0); probeMore(); }
    else { modalMain.innerHTML = '<div style="color:#aaa">— ' + esc(T.noImage) + ' —</div>'; modalThumbs.innerHTML = ''; }
    renderBody(it, true);
    fetch(API + '/storefront/pre-owned/stock/' + encodeURIComponent(it.id))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (modalCurrent !== it) return;
        if (d && d.ok && d.item) { d.item.price_krw = it.price_krw; d.item.price_local = it.price_local; d.item.currency = it.currency; renderBody(d.item, false); }
      })
      .catch(function () {});
  }

  /* ── Init ── */
  STATE.sort = 'newest';
  runSearch();
})();
